import { DeleteProjectModal } from "./components/ProjectForm/DeleteProjectModal";
import { ProjectFormModal } from "./components/ProjectForm/ProjectFormModal";
import { ProjectTableSection } from "./components/ProjectList/ProjectTableSection";
import { ProjectToolbar } from "./components/ProjectToolbar/ProjectToolbar";
import { useRaasClientPortalController } from "./hooks/useRaasClientPortalController";
import { RaasProjectAccessDenied } from "./RaasProjectAccessDenied";
import {
  Eyebrow,
  Header,
  Headline,
  Page,
  PageInner,
} from "./RaasClientPortal.styled";

const RaasClientPortal = () => {
  const {
    accessDenied,
    deleteProjectModal,
    header,
    projectFormModal,
    tableSection,
    toolbar,
  } = useRaasClientPortalController();

  if (accessDenied.visible) {
    return (
      <RaasProjectAccessDenied
        description="You do not have permission to view projects for this user or account. Switch to a user with access, or return to your projects."
        onBackToProjects={accessDenied.onBackToProjects}
        title="Insufficient permissions"
      />
    );
  }

  return (
    <Page>
      <PageInner>
        <Header>
          <Eyebrow>
            {header.greeting}, {header.firstName}
          </Eyebrow>
          <Headline>
            <strong>
              {header.attentionCountLabel} {header.projectNoun}
            </strong>{" "}
            {header.headlineSuffix}
          </Headline>
        </Header>

        <ProjectToolbar {...toolbar} />

        <ProjectTableSection {...tableSection} />

        <ProjectFormModal {...projectFormModal} />

        <DeleteProjectModal {...deleteProjectModal} />
      </PageInner>
    </Page>
  );
};

export default RaasClientPortal;
